export default __webpack_public_path__ + "static/media/msf_s3.4c90c21a.png";